import { Component, computed, inject, Input, Signal } from '@angular/core';
import { ShowPerformance } from '../../../models/showperformance.model';
import { AuthStateService } from '../../auth/auth-state.service';

@Component({
    selector: 'app-performance-document-download-buttons-list',
    templateUrl: './performance-document-download-buttons-list.component.html',
    styleUrls: ['./performance-document-download-buttons-list.component.scss'],
    standalone: false
})
export class PerformanceDocumentDownloadButtonsListComponent {

    @Input() public performance: ShowPerformance;
    @Input() public showShowreport: boolean = true;
    @Input() public shortNames: boolean = false;

    private readonly authStateService = inject(AuthStateService);

    /**
     * Per-show toggles for the two download buttons. Bound to the active
     * show signal so that an admin flipping the flag in show-edit (which
     * pushes through `setActiveShow`) updates the buttons reactively
     * without a reload.
     */
    public readonly showCallsheetButton: Signal<boolean> = computed(
        () => this.authStateService.activeShow()?.hasCallsheetButton === true
    );
    public readonly showEftelingShowreportButton: Signal<boolean> = computed(
        () => this.authStateService.activeShow()?.hasEftelingShowreportButton === true
    );

    public hasEftelingShowreport(): boolean {
        return (
            this.performance?.documents?.some(
                document => document.documentType === 'EFTELINGSHOWREPORT' && document.downloadToken != null
            ) || false
        );
    }

    public hasCallsheet(): boolean {
        return (
            this.performance?.documents?.some(
                document => document.documentType === 'CALLSHEET' && document.downloadToken != null
            ) || false
        );
    }

    public getCallsheetUrl(): string | null {
        const document = this.performance?.documents?.find(
            doc => doc.documentType === 'CALLSHEET'
        );
        return document?.downloadToken ?? null;
    }

    public getEftelingShowreportUrl(): string | null {
        const document = this.performance?.documents?.find(
            doc => doc.documentType === 'EFTELINGSHOWREPORT'
        );
        return document?.downloadToken ?? null;
    }

    public isToday(): boolean {
        if (!this.performance?.datetime) {
            return false;
        }
        const today = new Date();
        const performanceDate = new Date(this.performance.datetime);

        return (
            today.getFullYear() === performanceDate.getFullYear() &&            today.getMonth() === performanceDate.getMonth() &&            today.getDate() === performanceDate.getDate()
        );
    }

}
